import React from "react";
import Modal from "react-bootstrap/Modal";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";

export const ModalSize = {
  small: "sm",
  medium: "",
  large: "lg",
  extraLarge: "xl",
};

const StyledModal = styled(Modal)`
  .modal-sm {
    max-width: 390px;
  }
  .modal-content {
    padding: 1rem;
    border: 0px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.6rem;
  }
  .close {
    font-size: 2.5rem;
    padding-top: 0.5rem;
  }
  .btn-close {
    box-shadow: none;
  }
  .modal-title {
    overflow: hidden;
    .header-text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  @media (max-width: 576px) {
    padding-left: 0px !important;

    .modal-sm {
      max-width: 100%;
    }

    .modal-body {
      margin: 1rem;
      padding: 0;
      .auth-form {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }
    .modal-dialog {
      margin: 0;
      align-items: unset;
      min-height: 100%;
    }
    .modal-content {
      border-radius: 0;
      padding: 16px 8px;
    }
    .btn-auth {
      bottom: 1rem;
      left: 0;
      margin-top: auto !important;
    }
  }

  @media (max-width: 320px) {
    .invalid-input {
      font-size: 11px;
    }
    .privacy-terms {
      font-size: 14px;
    }
    .btn-auth {
      bottom: 0;
    }
  }
`;

const TitleSeparator = styled.div`
  width: 40px;
  height: 3px;
  margin-top: 0.3rem;
  background: ${(props) => props?.$background ?? props?.theme?.purpleGradient};
`;

const CustomModal = (props) => {
  const { show, title, size, centered, onClose, children, titleSeparatorBg } =
    props;

  const handleOnHide = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <StyledModal
      show={show}
      data-testid={props["data-testid"] ?? "modal"}
      onHide={handleOnHide}
      backdrop="static"
      keyboard={false}
      size={size}
      centered={centered}
    >
      <Modal.Header className="border-0" closeButton>
        <Modal.Title>
          <div>
            <h5 className="header-text">{title}</h5>
            <TitleSeparator $background={titleSeparatorBg} />
          </div>
        </Modal.Title>
      </Modal.Header>

      {children && <Modal.Body>{children}</Modal.Body>}
    </StyledModal>
  );
};

CustomModal.defaultProps = {
  onClose: null,
  centered: true,
  children: null,
  titleSeparatorBg: null,
  size: "",
};

CustomModal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  titleSeparatorBg: PropTypes.string,
  size: PropTypes.oneOf(["sm", "", "lg", "xl"]),
};

export default withTheme(CustomModal);
